// extracted by mini-css-extract-plugin
export var actionText = "_p9-4";
export var container = "_p9-0";
export var leftSection = "_p9-1";
export var rightSection = "_p9-2";
export var settingsButton = "_p9-6";
export var settingsIcon = "_p9-7";
export var shortcut = "_p9-5";
export var shortcutGroup = "_p9-3";